// Source: app/scripts/controllers/republish-auction.js
/**
 * Created by riste_000 on 4/7/2015.
 */


Auction.controller('RepublishAuctionController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$location',
  'toaster',
  'Auction',
  'crudService',
  function ($scope, $filter, $routeParams, $location, toaster, Auction, crudService) {

    $scope.auctionId = $routeParams.auctionId;
    Auction.get({
      id: $scope.auctionId
    }, function (data) {
      $scope.entity = data;
      $scope.entity.detail = {};
      Auction.loadDetails({
        id: $scope.auctionId
      }, function (data) {
        $scope.entity.detail = data || {};
      });
    });


    var service = crudService('auction', {
      republish: {
        method: 'POST',
        url: '/data/rest/auctions/republish'
      }
    });

    $scope.republish = function () {
      service.republish($scope.entity, function () {
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("eauction.republish_success"));
        $location.path("/");
      });
    };

  }]);
